module.exports = __webpack_public_path__ + "static/media/checkout.4d869791.svg";